<script setup>
import ProductTeaserAddToCart from "./ProductTeaserAddToCart";
import {ref} from "vue";
import {usePiniaStore} from "../store/pinia_store";
import {parseInt, isEmpty} from "lodash";

const props = defineProps({
    crmId: {
        type: String,
        required: true,
    },
    dentaidApiInstance: {
        type: Function,
        required: true,
    },
    product: {
        type: Object,
        required: true,
    },
    cartEventBus: {
        type: Object,
        required: true,
    },
    eventBus: {
        type: Object,
        required: true,
    },
    price: {
        type: Object,
        required: true,
    }
})

const piniaStore = usePiniaStore();

const language = ref(window.drupalSettings.ef2_custom.language ?? 'nl');

const authenticated = ref(!isEmpty(drupalSettings.ef2_custom.customer_number))
</script>

<template>
    <div class="col-12 col-sm-6 col-lg-4 col-xl-3 views-row">
        <div class="contextual-region node node--type-product node--view-mode-teaser layout layout-product-teaser">
            <div class="field field--name-field-product-teaser-image field--type-image field--label-hidden field__item">
                <a :href="product.url">
                    <img :src="product.product_teaser_image" width="214" height="350" alt="Product image" loading="lazy"
                         typeof="foaf:Image" class="image-style-product-teaser clickable" style="cursor: pointer;">
                </a>
            </div>

            <div class="field field--name-node-title field--type-ds field--label-hidden field__item">
                <h2 class="virtual-h3">
                    <a :href="product.url"
                       hreflang="nl">
                        {{ product.product_title }}</a>
                </h2>
            </div>

            <div class="vue-product-teaser-wrapper" v-if="authenticated">
                <dentaid-product-price
                    :crm-id="crmId"
                    :dentaid-api-instance="dentaidApiInstance"
                    :event-bus="eventBus"
                    :order-unit="parseInt(price.min_order_quantity)"
                    :is-teaser="true"
                    :price-list="price"
                    class="mb-4 mb-sm-2"
                ></dentaid-product-price>

                <dentaid-product-favorite
                    :crm-id="crmId"
                    :event-bus="eventBus"
                    :favorites="Object.assign({}, piniaStore.favorites)"
                    :dentaid-api-instance="dentaidApiInstance"
                ></dentaid-product-favorite>

                <ProductTeaserAddToCart
                    :order-unit="parseInt(price.min_order_quantity)"
                    :incremental-order-unit="parseInt(price.incremental_order_quantity)"
                    :crm-id="crmId"
                    :event-bus="eventBus"
                    :dentaid-api-instance="dentaidApiInstance"
                    :product-title="product.product_title"
                    :brand-title="product.brand_title"
                    :cart-event-bus="cartEventBus"
                ></ProductTeaserAddToCart>
            </div>
        </div>
    </div>
</template>
